
  import { defineComponent, computed } from 'vue';
  import { ModalProps, modalProps, Modal } from '@/ui/components/Modal';
  import { ANALYTICS_FILE_ITEMS_MODAL_WIDTH } from '@/ui/components/modals/constants';
  import { ReportWidget } from '@/services/api/resources/analytics-builder/model';
  import { useWidgetFormItem } from '@/ui/concerns/analytics/widget';
  import { Icon } from '@/ui/components/icon/Icon';

  interface FileItemsModalProps extends ModalProps {
    data: string | null;
    widget: ReportWidget;
  }

  export default defineComponent<FileItemsModalProps>({
    components: {
      Modal,
      Icon,
    },
    props: [...modalProps, 'data', 'widget'],
    setup(props) {
      const { getFiles } = useWidgetFormItem(props.widget);
      const files = computed(() => {
        if (!props.data) {
          return [];
        }

        return getFiles(props.data);
      });

      return {
        ANALYTICS_FILE_ITEMS_MODAL_WIDTH,
        files,
      };
    },
  });
